import { render, staticRenderFns } from "./ExtratoUtilizacao_Beneficiario.vue?vue&type=template&id=093b1290&scoped=true&"
import script from "./ExtratoUtilizacao_Beneficiario.vue?vue&type=script&lang=js&"
export * from "./ExtratoUtilizacao_Beneficiario.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoUtilizacao_Beneficiario.vue?vue&type=style&index=0&id=093b1290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b1290",
  null
  
)

export default component.exports